module.exports = __webpack_public_path__ + "img/flight_outlined.1b03b567.svg";